<template>
  <div class="home page-container" >
    <!--banner-->
    <div class="banner">
      <!-- <div class="drop" @click="showclassify = !showclassify" v-if="this.$store.state.billboard.billboardImages.length>0">
          <i class="el-icon-caret-bottom"></i>
          <svg t="1598526610947" v-if="showclassify" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3534" width="64" height="64"><path d="M502.2 393.6m-163 0a163 163 0 1 0 326 0 163 163 0 1 0-326 0Z" fill="#AED7FF" p-id="3535"></path><path d="M197.5 363.4c0.1-1.4 0.2-2.7 0.3-4.1 12-147.5 137.4-263.1 285.6-263.1 151.5 0 275.8 118.2 285.9 267.2h20c-10-160-143.3-287.2-305.9-287.2-158.5 0-292.7 123.6-305.5 281.4-0.2 1.9-0.3 3.8-0.4 5.7h20zM768.1 414.9c-16 142.9-137.6 254.4-284.7 254.4s-268.6-109-284.7-254.4h-20.1c16.3 156.6 146.7 274.4 304.8 274.4 158.2 0 288.7-120.4 304.8-274.4h-20.1z" fill="#108EE9" p-id="3536"></path><path d="M483.4 160.3c-122.7 0-222.5 99.8-222.5 222.5s99.8 222.5 222.5 222.5 222.5-99.8 222.5-222.5c-0.1-122.7-99.9-222.5-222.5-222.5z m0 407.4c-102.1 0-184.9-82.8-184.9-184.9 0-102.1 82.8-184.9 184.9-184.9s184.9 82.8 184.9 184.9c0 102.1-82.8 184.9-184.9 184.9z" fill="#108EE9" p-id="3537"></path><path d="M483.4 510.7c-70.5 0-127.9-57.4-127.9-127.9s57.4-127.9 127.9-127.9 127.9 57.4 127.9 127.9-57.4 127.9-127.9 127.9z m0-209.3c-44.9 0-81.4 36.5-81.4 81.4s36.5 81.4 81.4 81.4c44.9 0 81.4-36.5 81.4-81.4s-36.6-81.4-81.4-81.4z" fill="#108EE9" p-id="3538"></path><path d="M433.2 563.8c0-51.5-0.2-103.1 0.1-154.6 0.2-36.1 18-57 48.2-57.2 32.1-0.2 54 22.6 54.2 57.8 0.4 57.4 0 114.8 0.2 172.2 0.1 30.5 7 38 39.5 40.9 65.3 5.7 130.6 11.1 195.9 16 41.3 3.1 57.7 20.5 49.6 58.2-16.4 76.4-34.4 152.6-51.1 228.9-4.5 20.8-18.2 30.5-39.7 31.4-29.5 1.3-59.1 2-88.7 2.1-83.2 0.3-166.4 0.2-249.6 0-32.3 0-42.7-6.7-52.8-34.7-27.9-77.3-55.5-154.7-83.2-232-8.1-22.5 4-47.3 27.4-56 22.2-8.2 52.7 2.8 62.4 24.2 11 24.4 21 49.3 30.1 74.3 5.4 14.8 13.6 26.7 31.6 24 19.2-3 26.3-16.8 26.2-34.4-0.5-53.7-0.4-107.4-0.3-161.1z" fill="#1195FE" p-id="3539"></path></svg>
          <svg t="1598526610947" v-else class="icon2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3534" width="64" height="64"><path d="M502.2 393.6m-163 0a163 163 0 1 0 326 0 163 163 0 1 0-326 0Z" fill="#AED7FF" p-id="3535"></path><path d="M197.5 363.4c0.1-1.4 0.2-2.7 0.3-4.1 12-147.5 137.4-263.1 285.6-263.1 151.5 0 275.8 118.2 285.9 267.2h20c-10-160-143.3-287.2-305.9-287.2-158.5 0-292.7 123.6-305.5 281.4-0.2 1.9-0.3 3.8-0.4 5.7h20zM768.1 414.9c-16 142.9-137.6 254.4-284.7 254.4s-268.6-109-284.7-254.4h-20.1c16.3 156.6 146.7 274.4 304.8 274.4 158.2 0 288.7-120.4 304.8-274.4h-20.1z" fill="#108EE9" p-id="3536"></path><path d="M483.4 160.3c-122.7 0-222.5 99.8-222.5 222.5s99.8 222.5 222.5 222.5 222.5-99.8 222.5-222.5c-0.1-122.7-99.9-222.5-222.5-222.5z m0 407.4c-102.1 0-184.9-82.8-184.9-184.9 0-102.1 82.8-184.9 184.9-184.9s184.9 82.8 184.9 184.9c0 102.1-82.8 184.9-184.9 184.9z" fill="#108EE9" p-id="3537"></path><path d="M483.4 510.7c-70.5 0-127.9-57.4-127.9-127.9s57.4-127.9 127.9-127.9 127.9 57.4 127.9 127.9-57.4 127.9-127.9 127.9z m0-209.3c-44.9 0-81.4 36.5-81.4 81.4s36.5 81.4 81.4 81.4c44.9 0 81.4-36.5 81.4-81.4s-36.6-81.4-81.4-81.4z" fill="#108EE9" p-id="3538"></path><path d="M433.2 563.8c0-51.5-0.2-103.1 0.1-154.6 0.2-36.1 18-57 48.2-57.2 32.1-0.2 54 22.6 54.2 57.8 0.4 57.4 0 114.8 0.2 172.2 0.1 30.5 7 38 39.5 40.9 65.3 5.7 130.6 11.1 195.9 16 41.3 3.1 57.7 20.5 49.6 58.2-16.4 76.4-34.4 152.6-51.1 228.9-4.5 20.8-18.2 30.5-39.7 31.4-29.5 1.3-59.1 2-88.7 2.1-83.2 0.3-166.4 0.2-249.6 0-32.3 0-42.7-6.7-52.8-34.7-27.9-77.3-55.5-154.7-83.2-232-8.1-22.5 4-47.3 27.4-56 22.2-8.2 52.7 2.8 62.4 24.2 11 24.4 21 49.3 30.1 74.3 5.4 14.8 13.6 26.7 31.6 24 19.2-3 26.3-16.8 26.2-34.4-0.5-53.7-0.4-107.4-0.3-161.1z" fill="#1195FE" p-id="3539"></path></svg>
      </div>  -->
      <el-collapse-transition>
        <div class="classify" v-show="showclassify" @mouseleave='noneClassify()'  :class="{'isActive':classright}">
          <div class="classleft">
            <ul class="classifyList">
              <div class="bac"></div>
              <li v-for="(item,index) in allGroups" :key="index" @click="navGoGroup(item.ProductGroup_id)" @mouseover='selectClassify(item.ProductGroup_id)' :class="{'isActiveList':classifyShow == item.ProductGroup_id}">
                <span v-if="$i18n.locale=='en'">{{item.Name}}</span>
                <span v-if="$i18n.locale=='ch'">{{item.Description}}</span>
                <i class="el-icon-arrow-right"></i>
              </li>
            </ul>
          </div>

          <div class="classright">
            <div class="scl">
              <div class="bac"></div>
              <ul>
                <li v-for="(item,index) in dataListsChild" :key="index" @click="navGo(item.ProductCategory_id)" >
                  <div class="img">
                    <img src="../assets/img/step_1.png" alt="">
                  </div>
                  <span v-if="$i18n.locale=='en'">{{item.Name}}</span>
                  <span v-if="$i18n.locale=='ch'">{{item.Description}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-collapse-transition>
      <swiper :options="bannerSwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in filterBillboard(this.$store.state.billboard.billboardImages, $i18n.locale)" data-index="index" :key="index">
          <div v-if="item.URL" ><a :href="item.URL"><img class='swiImg' :src='item.Image'/></a></div>
          <div v-else ><img class='swiImg' :src='item.Image'/></div>
        </swiper-slide>
        <!-- 分页器 -->
        <div class="swiper-pagination"  slot="pagination"></div>  
      </swiper>
      <div class="banner-button-prev"></div>
      <div class="banner-button-next"></div>
    </div>
    <!--end banner-->
    
    <!--see how it works-->
    <div class="Introduction">
      <!-- <div class="content">
        <div class="text-center">
          <h2>{{ $t('howItWorks') }}</h2>
        </div>
        <ul class="list">
          <li v-for="(item, index) in howToSlides" style="cursor: pointer;" data-index="index" :key="index" @click="howToModalOpen = true">
            <img class="howImg" :src="item.img" alt=""/>
            <div class="text-center">
              <span class="howTitle">{{ $t(item.title) }}</span>
              <p class="howInfo">{{ $t(item.info) }}</p>
            </div>
          </li>
        </ul>
      </div> -->

      <div class="rainbow">
        <img src="../assets/img/rainbow.png" alt="">
      </div>
      
      <!--modal-->
      <transition name="modal" v-if="howToModalOpen">
        <div class="modal-mask" @click="howToModalOpen = false">
          <div class="modal-wrapper">
            <div class="modal-container1" @click.stop>
              <div>
                <img class="img" src="../assets/img/step_modal.png" alt=""/>
                <div class="text-center">
                  <span class="title" >{{ $t('clickTitle') }}</span>
                  <p class="info" >{{ $t('clickInfo') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!--end modal-->
    </div>
    <!--end see how it works-->

    <div class="classification" v-for="(item,index) in this.$store.state.products.customCategories" :key="index" v-model="local=item.Products=='local'">
      <div class="content">
        <div class="text-center">
          <h2 v-if='$i18n.locale=="en"'>{{item.Name}}</h2>
          <h2 v-if='$i18n.locale=="ch"'>{{item.Description}}</h2>
        </div>
        <ul class="orderList">
          <div class="otderListLeft" :style="{background:mathColor()}">
            <productCardLeft v-if='$i18n.locale=="en"'
              v-bind:img="item.Products[0].Thumbnail"
              v-bind:link="item.Products[0].link"
              v-bind:name="item.Products[0].Name"
              v-bind:isPromotion="item.Products[0].IsPromotion"
              v-bind:price="item.Products[0].Price"
              v-bind:item="item.Products[0]"
              v-bind:quantity="item.Products[0].Quantity"
              v-bind:key="index" 
              v-bind:endTime="item.Products[0].EndTime"
              v-bind:GroupedSaleLimit="item.Products[0].GroupedSaleLimit"
              v-bind:GroupSoldQuantity="item.Products[0].GroupSoldQuantity"
            ></productCardLeft>
             <productCardLeft v-if='$i18n.locale=="ch"'
              v-bind:img="item.Products[0].Thumbnail"
              v-bind:link="item.Products[0].link"
              v-bind:name="item.Products[0].Description"
              v-bind:isPromotion="item.Products[0].IsPromotion"
              v-bind:price="item.Products[0].Price"
              v-bind:item="item.Products[0]"
              v-bind:quantity="item.Products[0].Quantity"
              v-bind:key="index" 
              v-bind:endTime="item.Products[0].EndTime"
              v-bind:GroupedSaleLimit="item.Products[0].GroupedSaleLimit"
              v-bind:GroupSoldQuantity="item.Products[0].GroupSoldQuantity"
            ></productCardLeft>
            <!-- <div class="name" v-if='$i18n.locale=="en"'>{{ item.Products[0].Name }}</div>
            <div class="name" v-if='$i18n.locale=="ch"'>{{ item.Products[0].Description }}</div>
            <div class="price">
              <div :class="[item.Products[0].IsPromotion ? 'hot' : '']"><span>${{item.Products[0] ? item.Products[0].Price.toFixed(2) : ''}}</span></div>
              <div class="price_original" v-show="item.Products[0].IsPromotion"><span>${{item.Products[0].OriginalPrice ? item.Products[0].OriginalPrice.toFixed(2) : ''}}</span></div>
            </div>
            <div class="img" @click="goToProductDetail(item.Products[0])">
              <a :href="item.Products[0].link">
                <img :src="item.Products[0].Thumbnail" alt="">
              </a>
            </div> -->
          </div>
          <div class="otderListright" :class="{'otderListright2':item.Products.length<9}">
            <!-- &&index!=1 -->
            <!-- v-if="!p.IsStopSale&&index<10" -->
            <li v-for="(p, index) in item.Products" :key="index" >
              <productCard v-if='$i18n.locale=="en"'
                v-bind:img="p.Thumbnail"
                v-bind:link="p.link"
                v-bind:name="p.Name"
                v-bind:isPromotion="p.IsPromotion"
                v-bind:price="p.Price"
                v-bind:item="p"
                v-bind:quantity="p.Quantity"
                v-bind:key="index" 
                v-bind:endTime="p.EndTime"
                v-bind:GroupedSaleLimit="p.GroupedSaleLimit"
                v-bind:GroupSoldQuantity="p.GroupSoldQuantity"
              ></productCard>
              <productCard v-if='$i18n.locale=="ch"'
                v-bind:img="p.Thumbnail"
                v-bind:link="p.link"
                v-bind:name="p.Description"
                v-bind:isPromotion="p.IsPromotion"
                v-bind:price="p.Price"
                v-bind:item="p"
                v-bind:quantity="p.Quantity"
                v-bind:key="index" 
                v-bind:endTime="p.EndTime"
                v-bind:GroupedSaleLimit="p.GroupedSaleLimit"
                v-bind:GroupSoldQuantity="p.GroupSoldQuantity"
              ></productCard>
            </li>
          </div>
        </ul>
      </div>
      <div class="logoGray">
        <!-- <img src="../assets/img/logogray.png" alt=""> -->
      </div>
    </div>
    <!-- <div class="TestiMn">
      <img src="../assets/img/TestiMn.png" alt="">
      <div class="content">
        <span>{{ $t('homeAway') }}</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { isUserAuthenticated, flyToElement } from "../store/modules/cart";
import productCard from "./productCard";
import productCardLeft from "./productCardLeft";
import $ from 'jquery';
export default {
  name: "home",
  components: {
    productCard,
    productCardLeft,
  },
  data() {
    return {
      classright:false,
      classifyShow:null,
      dataListsChild:[],
      showclassify:true,

      // swiper api：https://www.swiper.com.cn/api/index.html (https://swiperjs.com/)
      bannerSwiper: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination'
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
      productSwiper: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp1',
          prevEl: '.swiper-button-prev.swp1',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      // howToSlides: [
      //   {
      //     img: require('../assets/img/step_1.png'),
      //     title: "howToTitle1",
      //     info: "howToInfo1",
      //   }, {
      //     img: require('../assets/img/step_2.png'),
      //     title: "howToTitle2",
      //     info: "howToInfo2",
      //   }, {
      //     img: require('../assets/img/step_3.png'),
      //     title: "howToTitle3",
      //     info: "howToInfo3",
      //   },{
      //     img: require('../assets/img/step_4.png'),
      //     title: "howToTitle4",
      //     info: "howToInfo4",
      //   }
      // ],
      howToModalOpen: false,
      inCart: null,
      flushBbottom: {
        slidesPerView: 1,
      },
      homeImgLeft: true,
    }
  },
  activated(){
    this.classright = false
    this.classifyShow = null
  },
  methods:{
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    selectClassify(id){
      this.classifyShow = id
      this.classright = true
      this.allGroups.forEach(item=>{
        if(item.ProductGroup_id == id){
          this.dataListsChild = item.Categories
        }
      })
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
    mathColor(){
      var Arr = ["#E1F0F6","#FCE2E1","#FFD0A7","#D4E1DE","radial-gradient(#112581, #0B1327,#000000)"]; 
      var c = Math.floor(Math.random() * Arr.length + 1)-1;
      return Arr[c]
    },
    noneClassify(){
      this.classright = false
      this.classifyShow = null
    },
    isOutOfStock(item) {
      console.log(item)
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    homeImgCountChange() {
      this.homeImgLeft = !this.homeImgLeft;
      return true;
    },
    goToCollections() {
      this.$router.push('/collections')
    },
    goToCategory2(cat2) {
      this.$router.push(`/category2/${cat2.Name.toLowerCase()}`)
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail() {
      alert('Not enough product in stock');
    },
    findRightElement(item, p) {
      if (item.Product_id === p) {
        return 
      }
    },
    filterBillboard(billboard, language) {
      const filterBillboard = billboard.filter(image => {
        return image.Language.toLowerCase() === language;
      });
      return filterBillboard;
    },
    addToCart: function(item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        .then(() => {
          flyToElement(event.target, $('.cart-link'));
        })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
          flyToElement(event.target, $('.cart-link'));
        })
      }
    },
    beforeRouteLeave(to, from, next) {
      if (isUserAuthenticated() && to.name === 'purchase') {
        this.$store.dispatch('cart/getCart')
        .then(() => {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
          cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          .then(() => {
            this.saveGrandTotal(this.necessaryCartItems.GrandTotal);
            this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          })
        })
      }
      this.clearPromoCode();
      this.clearCard();
      next();
    },
    navGo(id) {
      this.classright = false
      this.classifyShow = null
      const group = this.dataListsChild.filter( group => group.ProductCategory_id === id)[0];
      if(this.$router.currentRoute.params && this.$router.currentRoute.params.group) {
        if(this.$router.currentRoute.params.group.toLowerCase() !== group.Name.toLowerCase()) {
          this.$router.push(`/collections/${group.Name.toLowerCase()}`)
        }else {
          this.$root.fetchSelectedGroup(group.ProductCategory_id, 'category');
        }
      }else {
        this.$router.push(`/collections/${group.Name.toLowerCase()}`)
      }
    },
    navGoGroup(id) {
      const group = this.allGroups.filter( group => group.ProductGroup_id === id)[0];
      this.$router.push(`/collections/${group.Name.toLowerCase()}`)
    },
  },
  computed: mapState ({
    checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
    checkoutRadiusChecked: state => state.navbar.checkoutRadiusChecked,
    cartProductsList: state => state.cart.cartProductsList,
    token: state => state.auth.token,
    loggedIn: state => state.auth.loggedIn,
    itemCount: state => state.cart.itemCount,
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cartClicked: state => state.cart.cartClicked,
    itemAdded: state => state.cart.itemAdded,
    allGroups: state => state.navbar.allGroups,
    IsShareCreditUsed: (state) => state.checkout.IsShareCreditUsed,
  }),
  mounted() {
    this.$store.dispatch('billboard/fetchBillboardImages');
    this.$store.dispatch('products/fetchCustomCategories');
  },
  watch: {
  },
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/home.less";
@import "../assets/css/modal.less";
</style>



// WEBPACK FOOTER //
// src/view/home.vue